// extracted by mini-css-extract-plugin
export default {"handling":"handling-form_handling__nB2nS","row":"handling-form_row__mD70Q","containerField":"handling-form_containerField__TCky3","checkbox":"handling-form_checkbox__KnN9i"};